export const variantTechNotes = `
variantTechNotes: metafield(namespace: "technical_specs", key: "notes") {
  references (first: 10) {
    edges {
      node {
        ... on Metaobject {
          title: field (key: "title") {
            value
          }
          note: field (key: "note") {
            value
          }
          page: field (key: "page") {
            value
          }
        }
      }
    }
  }
}
`;

export const variantTechSpecs = `
variantTechSpecs: metafield(namespace: "technical_specs", key: "specs") {
  reference {
    ... on Metaobject {
      type
      fields {
        key
        type
        value
      }
      imageData: field (key: "image") {
        reference {
          ... on MediaImage {
            image {
              url
              altText
            }
          }
        }
      }
    }
  }
}
`;

export const cartNotesQuery = `
query CartNotesQuery {
  cartNotes: metaobjects(first:100, type:"cart_note"){
			edges{
				node{
					name: field(key:"name"){
						value
					}
					content: field(key:"content"){
						value
					}
					rules: field(key:"rules"){
						value
					}
					priority: field(key:"priority"){
						value
					}
          active: field(key:"active"){
						value
					}
    		}
		  }
  }
}`

export const productMetafields = `
productMetafields: metafields(identifiers: [
  {namespace: "vehicle", key: "bed-note"}
  {namespace: "vehicle", key: "body_style_label"}
  {namespace: "vehicle", key: "body_style_helptext"}
  {namespace: "vehicle", key: "length_label"}
  {namespace: "vehicle", key: "length_helptext"}
  {namespace: "vehicle", key: "always_show_bed_length"}
  {namespace: "vehicle", key: "option1_note"}
  {namespace: "vehicle", key: "option1_helptext"}
  {namespace: "vehicle", key: "always_show_option1"}
  {namespace: "vehicle", key: "option2_note"}
  {namespace: "vehicle", key: "option2_helptext"}
  {namespace: "vehicle", key: "always_show_option2"}
  {namespace: "vehicle", key: "option3_note"}
  {namespace: "vehicle", key: "option3_helptext"}
  {namespace: "vehicle", key: "always_show_option3"}
  {namespace: "yotpo", key: "hide_reviews"}
  {namespace: "yotpo", key: "hide_gallery"}
]) {
  namespace
  key
  value
}
`;

export const variantMetafields = `
variantMetafields: metafields(identifiers: [
  {namespace: "compatibility", key: "keys"}
]) {
  namespace
  key
  value
}
`;

// Requires CoreCompatibilityFrag fragment
export const variantCompatible = `
variantCompatible: metafield(namespace: "technical_specs", key: "compatible") {
  references (first: 10) {
    edges {
      node {
        ... on Metaobject {
          ...CoreCompatibility
        }
      }
    }
  }
}
`;

// Requires CoreCompatibilityFrag fragment
export const variantNotCompatible = `
variantNotCompatible: metafield(namespace: "technical_specs", key: "not_compatible") {
  references (first: 10) {
    edges {
      node {
        ... on Metaobject {
          ...CoreCompatibility
        }
      }
    }
  }
}
`;

export const CoreCompatibilityFrag = `
fragment CoreCompatibility on Metaobject {
	title: field (key: "title") {
		value
	}
	link: field (key: "link") {
		value
	}
	name: field (key: "image") {
		reference {
			... on MediaImage {
				id
				image {
					url
					altText
				}
			}
		}
	}
}
`;
